import { render, staticRenderFns } from "./CardListDate.vue?vue&type=template&id=20d76212&scoped=true"
import script from "./CardListDate.vue?vue&type=script&lang=js"
export * from "./CardListDate.vue?vue&type=script&lang=js"
import style0 from "./CardListDate.vue?vue&type=style&index=0&id=20d76212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d76212",
  null
  
)

export default component.exports